import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsFontawesomeComponent } from './simple-icons-fontawesome.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsFontawesomeComponent ],
    exports:      [ SimpleIconsFontawesomeComponent ],
    bootstrap:    []
})
export class SimpleIconsFontawesomeModule {}
